import { useLazyQuery } from "@apollo/client";
import { useContext, useEffect, useState } from "react";

import { AppContext } from "../context/context";
import { responseType } from "../utils/formTypes";
import {
  GetCompanySqlNumberConfig,
  GetSqlNumberConfig,
} from "../queries/queries";
import useUrlParams from "./useUrlParams";

export interface GetStdVoucherBooksDetails {
  id: number;
  vo_book_key: string;
  vo_book_desc: string;
  vo_book_start_no: string;
  vo_book_current_no: string;
  is_prefixed: boolean;
  prefix_str: string;
  suffix_str: string;
  separator: string;
  prefill_with_zero: boolean;
  prefill_width: number;
  is_book_system_based: boolean;
  hide_this_book: boolean;
  voucher_type: string;
  voucher_sub_type: string;
  ldgr_details?: {
    id: number;
    ldgr_desc: string;
  }[];
}

export interface SwCompanySqlNumbers {
  id: number;
  tableKey: string;
  tableDesc: string;
  startNo: string;
  currentNo: string;
  isPrefixed: boolean;
  prefixStr: string;
  suffixStr: string;
  separator: string;
  prefillWithZero: boolean;
  prefillWidth: number;
  customerID: number;
  companyID: number;
  finYrID: number;
  // customer: MstCustomer!;
  // finYr: AtsFinYr!;
}

export interface SwSqlNumbers {
  id: number;
  tableKey: string;
  tableDesc: string;
  startNo: string;
  currentNo: string;
  isPrefixed: boolean;
  prefixStr: string;
  suffixStr: string;
  separator: string;
  prefillWithZero: boolean;
  prefillWidth: number;
  customerID: number;
  finYrID: number;
  // customer: MstCustomer!
  // finYr: AtsFinYr!
}

interface GetCompanySqlNumberConfigResult {
  GetCompanySqlNumberConfig: SwCompanySqlNumbers[];
}

interface GetSqlNumberConfigResult {
  GetSqlNumberConfig: SwSqlNumbers[];
}

interface GetCompanySqlNumberConfigVar {
  token?: string;
  customerId: number;
  companyID: number;
  finYrId: number;
}

interface GetSqlNumberConfigVar {
  token?: string;
  customerId: number;
  finYrId: number;
}

export const useBillbooks = () => {
  const { state } = useContext(AppContext);
  const { customer_id, company_id } = useUrlParams();

  const [responseType, setResponseType] = useState<responseType[]>([]);

  const [getCompanySqlNumberConfig, { data, loading, error }] = useLazyQuery<
    GetCompanySqlNumberConfigResult,
    GetCompanySqlNumberConfigVar
  >(GetCompanySqlNumberConfig);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (customer_id && company_id && state.ActiveFinYr) {
          await getCompanySqlNumberConfig({
            variables: {
              customerId: customer_id,
              companyID: company_id,
              finYrId: state.ActiveFinYr.id,
            },
          }).then(({ data }) => {
            if (data) {
              setResponseType(
                data.GetCompanySqlNumberConfig.map((book) => ({
                  label: book.tableDesc,
                  value: book.id,
                }))
              );
            }
          });
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, [customer_id, company_id, state.ActiveFinYr, getCompanySqlNumberConfig]);
  return { voucherBooks: { data, loading, error, responseType } };
};

export const useCustomerBillbooks = () => {
  const { state } = useContext(AppContext);
  const { customer_id } = useUrlParams();

  const [responseType, setResponseType] = useState<responseType[]>([]);

  const [getSqlNumberConfig, { data, loading, error }] = useLazyQuery<
    GetSqlNumberConfigResult,
    GetSqlNumberConfigVar
  >(GetSqlNumberConfig);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (customer_id && state.ActiveFinYr) {
          await getSqlNumberConfig({
            variables: {
              customerId: customer_id,
              finYrId: state.ActiveFinYr.id,
            },
          }).then(({ data }) => {
            if (data) {
              setResponseType(
                data.GetSqlNumberConfig.map((book) => ({
                  label: book.tableDesc,
                  value: book.id,
                }))
              );
            }
          });
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, [getSqlNumberConfig, customer_id, state.ActiveFinYr]);

  return { voucherBooks: { data, loading, error, responseType } };
};
